<!-- start page title -->
<section class="bg-gradient-light-orange-light-pink">
    <div class="container">
        <div class="d-flex flex-column flex-md-row justify-content-end extra-small-screen align-items-end">
            <div class="w-100 w-md-50 page-title-extra-small">
                <h1 class="alt-font text-extra-dark-gray position-relative padding-90px-left padding-15px-right sm-padding-55px-left mb-md-0 sm-margin-20px-bottom"><span class="page-title-separator-line bg-black w-70px sm-w-40px"></span>Contact Us</h1>
            </div>
            <div class="w-100 w-md-50">
                <h4 class="alt-font font-weight-500 text-extra-dark-gray mb-0">How can we help you?</h4>
            </div>
        </div>
    </div>
</section>
<!-- end page title --> 
<!-- start section -->
<section>
    <div class="container">
        <div class="row align-items-end">
            <div class="col-12 col-lg-6 col-md-4 sm-margin-30px-bottom">
                <h5 class="alt-font w-50 text-extra-dark-gray font-weight-500 mb-0 lg-w-65 md-w-100">Our Office</h5>
            </div>
            <div class="col-12 col-lg-6 col-md-8">
                <div class="row">
                    <div class="col-12 col-sm-6 xs-margin-30px-bottom"> 
                        <span class="alt-font d-block text-extra-dark-gray font-weight-500 margin-10px-bottom">Head Office</span>
                        <p class="w-80 margin-5px-bottom lg-w-90">75/85 O'Riordan St, Alexandria NSW 2015</p>
                        <span class="d-block margin-10px-bottom">Tel: (02) 8338 8763</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end section -->
<!-- start map section -->
<section class="no-padding-tb wow animate__fadeIn">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 px-0">
                <div class="map-style-3 h-500px xs-h-300px">
                    <iframe class="w-100 h-100 filter-grayscale-100" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6621.791544728304!2d151.193079!3d-33.918082!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe3af2e584f04b438!2sMail%20N%20Parcel!5e0!3m2!1sen!2sau!4v1616961299562!5m2!1sen!2sau"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end map section -->
<!-- start section -->
<section class="half-section">
    <div class="container">
        <div class="row justify-content-center">
            <!-- start feature box item-->
            <div class="col-12 col-sm-auto sm-margin-15px-bottom wow animate__fadeIn" data-wow-delay="0.2s">
                <div class="d-flex justify-content-center align-items-center padding-15px-lr h-100">
                    <i class="feather icon-feather-headphones align-middle icon-extra-small text-gradient-magenta-orange margin-10px-right"></i>
                    <span class="text-extra-dark-gray alt-font text-medium">(02) 8339 1668</span>
                </div>
            </div>
            <!-- end feature box item-->
            <!-- start feature box item-->
            <div class="col-12 col-sm-auto sm-margin-15px-bottom wow animate__fadeIn" data-wow-delay="0.4s">
                <div class="d-flex justify-content-center align-items-center padding-15px-lr h-100">
                    <i class="feather icon-feather-mail align-middle icon-extra-small text-gradient-magenta-orange margin-10px-right"></i>
                    <a href="mailto:no-reply@domain.com" class="text-extra-dark-gray alt-font text-medium">admin@parcelplusfrontend.com.au</a>
                </div>
            </div>
            <!-- end feature box item-->
            <!-- start feature box item-->
            <div class="col-12 col-sm-auto wow animate__fadeIn" data-wow-delay="0.6s">
                <div class="d-flex justify-content-center align-items-center padding-15px-lr h-100">
                    <i class="feather icon-feather-globe align-middle icon-extra-small text-gradient-magenta-orange margin-10px-right"></i>
                    <a href="#" class="text-extra-dark-gray alt-font text-medium">https://parcelplusfrontend.com.au/</a>
                </div>
            </div>
            <!-- end feature box item-->
        </div>  
    </div>
</section>
<!-- end section -->